__turbopack_context__.v({
  "ctaBanner": "FullLoadBooking-module-scss-module__phaMzG__ctaBanner",
  "ctaBg": "FullLoadBooking-module-scss-module__phaMzG__ctaBg",
  "ctaBtn": "FullLoadBooking-module-scss-module__phaMzG__ctaBtn",
  "ctarow": "FullLoadBooking-module-scss-module__phaMzG__ctarow",
  "herroSection": "FullLoadBooking-module-scss-module__phaMzG__herroSection",
  "imageWrap": "FullLoadBooking-module-scss-module__phaMzG__imageWrap",
  "imgBox": "FullLoadBooking-module-scss-module__phaMzG__imgBox",
  "intro": "FullLoadBooking-module-scss-module__phaMzG__intro",
  "main": "FullLoadBooking-module-scss-module__phaMzG__main",
  "textBox": "FullLoadBooking-module-scss-module__phaMzG__textBox",
});
